/**
 * Context-sensitive help texts for the atlas-client application.
 *
 * Register help texts here using `registerHelpText(id, content)`.
 * The `id` matches the value of `data-help` attributes on HTML elements.
 * The `content` supports HTML markup.
 *
 * Example:
 * ```html
 * <button data-help="map-zoom-help">+</button>
 * ```
 */

// TODO: Redesign this. The help texts should not be all concentrated here.

import { registerHelpText } from 'gertrud'

export function registerAppHelpTexts(): void {

    registerHelpText("context-help-button",
        `<p>Der <strong>Kontexthilfe</strong>-Modus ermöglicht es Ihnen, Hilfeinformationen zu
        einzelnen Elementen der Benutzeroberfläche abzurufen.</p>
        <p>Aktivieren Sie den Modus und klicken Sie anschließend auf ein Element, zu dem Sie
        Hilfe wünschen. Elemente mit verfügbaren Hilfeinformationen werden durch eine
        gestrichelte Umrandung hervorgehoben.</p>
        <p>Zum Deaktivieren klicken Sie erneut auf die Schaltfläche.</p>`)

    registerHelpText("app-home-button",
        `<p>Bringt Sie zurück zur <strong>Startseite</strong> des Metropolatlas.</p>
        <p>Von dort aus können Sie einen anderen Kartenbereich auswählen oder die
        Kartenansicht neu starten.</p>`)

    registerHelpText("mrn-button",
        `<p>Öffnet die Website der <strong>Metropolregion Rhein-Neckar (MRN)</strong>
        in einem neuen Tab.</p>
        <p>Dort finden Sie Informationen über die Region, aktuelle Projekte und
        Veranstaltungen.</p>`)

    registerHelpText("messages-button",
        `<p>Zeigt das <strong>Nachrichtenzentrum</strong> an.</p>
        <p>Hier finden Sie Systemnachrichten, Benachrichtigungen und wichtige
        Informationen zu Ihrer aktuellen Sitzung.</p>
        <p>Ungelesene Nachrichten werden durch einen Zahlenindikator auf der
        Schaltfläche angezeigt.</p>`)

    registerHelpText("map-module-opacity-slider", `
            
            <p>Mit diesem Regler kann die Deckkraft/Transparenz der von dem Kartenmodul verwalteten Kartenebene(n) eingestellt werden.</p>
            <p>Ein Wert von 0 (Regler ganz links) bedeutet, dass die Kartenebene vollständig transparent ist und dementsprechend überhaupt nicht angezeigt wird.</p>
            <p>Ein Wert von 1 (Regler ganz rechts) bedeutet, dass die Kartenebene mit voller Deckkraft (keine Transparenz) gezeichnet wird und dementsprechend
            alle darunterliegenden Kartenebenen vollständig überdeckt. Ausgenommen davon sind Bereiche, die im Kartenbild der Ebene selbst als vollständig oder 
            teilweise transparent definiert sind.
            </p>.
            `)

    registerHelpText("time-range-selector", `
            <p>Mit diesem Regler kann ein <strong>Zeitraum</strong> (Start- und Endjahr) ausgewählt werden.</p>
            <p>Ziehen Sie die beiden Griffe mit der Maus, um den Beginn und das Ende des Zeitraums festzulegen.</p>
            <p>Alternativ können Sie die Griffe mit der <strong>Tastatur</strong> bedienen: Fokussieren Sie einen Griff
            (Tab-Taste) und verschieben Sie ihn mit den Pfeiltasten. Mit <strong>Bild auf/ab</strong> springen Sie in
            größeren Schritten, mit <strong>Pos1/Ende</strong> direkt zum Anfang bzw. Ende des Zeitstrahls.</p>`)

    // Further help texts can be added here as the application grows.
    // For example:
    // registerHelpText("layer-legend", "<p>Erklärung der Kartendarstellung...</p>")
    // registerHelpText("search-bar", "<p>So suchen Sie nach Orten...</p>")
}